// extracted by mini-css-extract-plugin
export default {"header":"header--cinbP","goBack":"goBack--ssFg3"};